import React, { Component } from 'react';
import { Button, Grid, SwipeableDrawer, Typography, Divider, Badge } from '@mui/material';
import MOBILE_CLASSES from './mobileStylesClasses';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import Views from './Views/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars,
    faBell,
    faTimes,
    faCalendarAlt,
    faCalendarWeek,
    faCalendarDay,
    faArrowLeft
} from '@fortawesome/pro-light-svg-icons';
import SettingTitle from '../../../../common/components/UI/Title/SettingTitle';
import FilterPanel from './filterPanel';
import HistoryPanel from './historyPanel';
import NotificationPanel from './notificationPanel';
import { connect } from "react-redux";
import {
    updateEmployeeDashboardData,
    updateSnackbar,
    updateLoading,
    updateDismissNotificationData,
} from "../../actions";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import * as UI from "../Utils/uiGenerators";
import * as Handlers from '../Utils/handlers';
import DismissConfirmation from './SidePanelActions/dismissConfirmation';

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const anchorLeft = "left";
const anchorRight = "right";
class TopBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            left: false,
            right: false,
        }
    }

    toggleDrawer = (anchor, open) => (event) => {
        if (event) {
            event.stopPropagation()
            if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
                return;
            }
        }

        this.setState({
            [anchor]: open
        }, () => {
            if (anchor === anchorRight) {
                const { storeData } = this.props;
                if (!storeData.privateOffersSummary.loadedIds.length && storeData.privateOffersSummary.offerIds.length > 0) {
                    this.handleLoadMoreNotifications();
                }
            }
        });
    };

    handleLoadMoreNotifications() {
        Handlers.loadNextNotifications.bind(this)();
    }

    closeDrawerAndExecute(anchor, action = () => { }) {
        action();
        this.setState({
            [anchor]: false
        });
    }

    renderNameSection(classes) {
        let person = this.props.person;
        return (
            <div className={classes.topBarNameSection}>
                {person.personName}
            </div>
        );
    }


    renderMenuItem(classes, icon, name, action = () => { }) {
        return (
            <div className={classes.topBarMenuItem} onClick={() => { this.closeDrawerAndExecute(anchorLeft, action) }}>
                <FontAwesomeIcon icon={icon} /> {name}
            </div>
        );
    }

    renderMenu() {
        const {
            classes,
            dailyViewMenuClick,
            globalConfigs,
            listViewMenuClick,
            monthlyViewMenuClick,
            onHistoryElementClick,
            t,
        } = this.props;

        return (
            <div className={classes.topBarMenu}>
                {this.renderMenuItem(classes, faCalendarAlt, t('menu.monthlyView'), monthlyViewMenuClick)}
                {this.renderMenuItem(classes, faCalendarWeek, t('menu.listView'), listViewMenuClick)}
                {this.renderMenuItem(classes, faCalendarDay, t('menu.dailyView'), dailyViewMenuClick)}
                <FilterPanel
                    classes={classes}
                    t={t}
                    handleLoadToCoverOffers={this.props.handleLoadToCoverOffers}
                />
                <HistoryPanel classes={classes}
                    t={t}
                    handleClick={onHistoryElementClick}
                />
                {!!globalConfigs?.isAllEmployeeOffersEnabled && <Views classes={classes} />}

            </div>
        );

    }

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    render() {
        const { classes, t, person, storeData, statusDictionary } = this.props;


        return (
            <React.Fragment>
                <Grid container className={classes.topBar} alignItems={'center'}>
                    <Grid item xs={2} className={classes.lightBorderRight}>
                        <Button onClick={this.toggleDrawer(anchorLeft, true)} className={clsx(classes.button, classes.buttonTopBar)}><FontAwesomeIcon icon={faBars} /></Button>
                    </Grid>
                    <Grid item xs={8} className={classes.topBarAppName}>
                        <SettingTitle
                            titleText={t('settings.appName')}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Button onClick={this.toggleDrawer(anchorRight, true)} className={clsx(classes.button, classes.buttonTopBar)}>
                            <Badge overlap="rectangular" badgeContent={storeData.privateOffersSummary.new} color="secondary" classes={{ badge: classes.badgeSize }}>
                                {storeData.privateOffersSummary.new ?
                                    <NotificationsActiveIcon classes={{ root: classes.bellIcon }} style={{ color: '#EE0F0F' }} />
                                    : <FontAwesomeIcon icon={faBell} />}
                            </Badge>
                        </Button>
                    </Grid>
                </Grid>
                <SwipeableDrawer anchor={anchorLeft} open={this.state[anchorLeft]} onOpen={this.toggleDrawer(anchorLeft, true)} onClose={this.toggleDrawer(anchorLeft, false)} disableBackdropTransition={!iOS} disableDiscovery={iOS} >
                    <div className={classes.topBarExit} >
                        <Button onClick={this.toggleDrawer(anchorLeft, false)} className={clsx(classes.button, classes.exitButtonTopBar)}><FontAwesomeIcon icon={faTimes} size="2x" /></Button>
                    </div>
                    {this.renderNameSection(classes)}
                    {this.renderMenu()}
                </SwipeableDrawer>
                <SwipeableDrawer anchor={anchorRight} open={this.state[anchorRight]} onOpen={this.toggleDrawer(anchorRight, true)} onClose={this.toggleDrawer(anchorRight, false)} classes={{ paper: classes.drawerPaper }}>
                    <div className={classes.notificationsExit} >
                        <Button onClick={this.toggleDrawer(anchorRight, false)} className={clsx(classes.button, classes.notificationsExitButton)}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                        <Typography className={classes.NotificationsTitle}> {t('notifications.header')} </Typography>
                    </div>
                    <Divider />

                    {!this.props.dismissNotificationData.open ?
                        <NotificationPanel
                            parsedNotifList={UI.standardizeNotificationList(person.currentEmployeeId, storeData.privateOffers, statusDictionary)}
                            closeDrawerAndExecute={() => this.closeDrawerAndExecute(anchorRight)}
                            classes={classes} t={t}
                            handleLoadMoreNotifications={this.handleLoadMoreNotifications.bind(this)}
                        />
                        :
                        <DismissConfirmation />
                    }

                </SwipeableDrawer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        classes: MOBILE_CLASSES,
        dateRanges: state.dateRanges,
        globalConfigs: state.globalConfigs,
        list: state.data.privateOffers,
        options: state.httpOptions,
        person: state.person,
        statusDictionary: state.statusDictionary,
        storeData: state.data,
        dismissNotificationData: state.dismissNotificationData,
        managerSettings: state.managerSettings,
    };
};

const mapDispatchToProps = {
    updateLoading,
    updateSnackbar,
    updateEmployeeDashboardData,
    updateDismissNotificationData
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(TopBar));
